<template>
    <div class="detail-component">
      <!-- 标题栏 -->
      <div class="header">
        <!-- 返回按钮 -->
        <button class="back-button" @click="goBack">
          <img src="@/assets/back-arrow.png" alt="返回" class="back-icon" />
        </button>
        <!-- 标题 -->
        <h1 class="title">{{ detail.title }}</h1>
      </div>
  
      <!-- 详情内容 -->
      <img :src="detail.image" alt="图片" class="detail-image" />
      <p>价格：{{ detail.price }}</p>
      <p>标签：{{ detail.tags.join(', ') }}</p>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref, onMounted } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  
  export default defineComponent({
    name: 'DetailComponent',
    setup() {
      const route = useRoute(); // 获取路由参数
      const router = useRouter(); // 获取路由实例
      const detail = ref({
        id: '',
        title: '',
        tags: [] as string[],
        price: '',
        image: '',
      });
  
      // 模拟根据 ID 获取详情数据
      const fetchDetail = (id: string) => {
        const mockData = [
          {
            id: '1',
            title: '溪畔民宿，流水潺潺',
            tags: ['民宿', '荷花'],
            price: '¥ 50,000 / 年',
            image: 'https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1098.jpg',
          },
          {
            id: '2',
            title: '古镇民宿，感受历史韵味',
            tags: ['民宿', '古镇'],
            price: '¥ 1,20,000 / 年',
            image: 'https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1099.jpg',
          },
          {
            id: '3',
            title: '千年茶乡用地，传承茶文化',
            tags: ['茶叶', '交通便利'],
            price: '¥ 800,000 / 亩',
            image: 'https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1100.jpg',
          },
          {
            id: '4',
            title: '生态林业用地，天然氧吧',
            tags: ['林地'],
            price: '¥ 1800,000 / 公顷',
            image: 'https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1101.jpg',
          },
          {
            id: '5',
            title: '乡村宅基地，田园生活新选择',
            tags: ['宅基地', '交通便利'],
            price: '面议',
            image: 'https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1102.jpg',
          },
          {
            id: '6',
            title: '山林养鸡地，自由奔跑',
            tags: ['养鸡'],
            price: '¥ 280,00 / 亩 / 年',
            image: 'https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1103.jpg',
          },
          {
            id: '7',
            title: '田园风情民宿用地，拥抱自然',
            tags: ['民宿', '田园'],
            price: '¥ 800,000',
            image: 'https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1104.jpg',
          },
          {
            id: '8',
            title: '花海民宿用地，四季如画',
            tags: ['民宿', '交通便利'],
            price: '面议',
            image: 'https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1105.jpg',
          },
          {
            id: '9',
            title: '温泉民宿用地，冬日暖意',
            tags: ['民宿', '温泉'],
            price: '¥ 280,000 / 年',
            image: 'https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1106.jpg',
          },
        ];
  
        const result = mockData.find((item) => item.id === id);
        if (result) {
          detail.value = result;
        }
      };
  
      // 返回上一页
      const goBack = () => {
        router.go(-1);
      };
  
      // 组件挂载时获取详情数据
      onMounted(() => {
        const id = route.params.id as string; // 获取路由参数
        fetchDetail(id);
      });
  
      return {
        detail,
        goBack,
      };
    },
  });
  </script>
  
  <style scoped>
  .detail-component {
    padding: 20px;
  }
  
  /* 标题栏样式 */
  .header {
    display: flex;
    align-items: center; /* 垂直居中 */
    margin-bottom: 20px;
  }
  
  /* 返回按钮样式 */
  .back-button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    margin-right: 10px; /* 与标题的间距 */
  }
  
  /* 返回图标样式 */
  .back-icon {
    width: 24px; /* 图标大小 */
    height: 24px;
  }
  
  /* 标题样式 */
  .title {
    margin: 0;
    font-size: 24px;
    flex: 1; /* 占据剩余空间 */
  }
  
  /* 详情图片样式 */
  .detail-image {
    width: 100%;
    max-width: 400px;
    height: auto;
    border-radius: 10px;
    margin-bottom: 20px;
  }
  </style>